export default __webpack_public_path__ + "static/media/background3.aa2b406b.jpg";